import { createContext,useContext } from 'react';

const MainContext = createContext();

export {
    MainContext,
    useContext
}